import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "amfe-flexible";
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min";
import "@/assets/common/font/font.css";
import animated from "animate.css";
import axios from './http';

Vue.use(animated);
import {
  Popup,
  Collapse, 
  CollapseItem,
//   Tab,
//   Tabs,
//   Grid,
//   GridItem,
  // Form,
  // Field,
  Button,
  Icon,
  // Toast,
  // Search,
//   Dialog
  // Sticky,
  // Uploader,
  // Cell,
  // CellGroup,
  // Radio,
  // RadioGroup,
  // Sidebar,
  // SidebarItem,
  // List,
  // Tag
  // Image as VanImage,
  // Popup,
  // Col,
  // Row,
  // DropdownItem,
  // DropdownMenu,
  // Loading,
  // Overlay,
  // PullRefresh,
  // SwipeCell,
  // Skeleton,
} from "vant"; //单独引入有赞ui
Vue.config.productionTip = false;

Vue.use(Popup); //单独引入有赞ui-下
Vue.use(Collapse);
Vue.use(CollapseItem);
// Vue.use(Tab);
// Vue.use(Tabs);
// Vue.use(Grid);
// Vue.use(GridItem);
// Vue.use(Form);
Vue.use(Button);
// Vue.use(Field);
Vue.use(Icon);
// Vue.use(Toast);
// Vue.use(Search);
// Vue.use(Dialog);
// Vue.use(Sticky);
// Vue.use(Sidebar);
// Vue.use(SidebarItem);
// Vue.use(List);
// Vue.use(Tag);
// Vue.use(DropdownMenu);
// Vue.use(DropdownItem);
// Vue.use(Uploader);
// Vue.use(CellGroup);
// Vue.use(Cell);
// Vue.use(Row);
// Vue.use(VanImage);
// Vue.use(Popup);
// Vue.use(Col);
// Vue.use(Row);
// Vue.use(RadioGroup);
// Vue.use(Radio);
// Vue.use(DropdownItem);
// Vue.use(Loading);
// Vue.use(Overlay);
// Vue.use(PullRefresh);
// Vue.use(SwipeCell);
// Vue.use(Skeleton);
Vue.prototype.$http = axios
//显示title标题
router.beforeEach((to, from, next) => {
	if (to.meta && to.meta.title) {
	  document.title = to.meta.title;
	}
	next();
  })
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
